// @flow
import $ from 'jquery';
import JQueryView, {
  on,
  removeInvalidFeedback,
} from '../../../common/JQueryView';
import maskInput from '../../../../utils/maskInput';
import { trimCommas } from '../../../../utils/commonUtils';
import DateRangePicker from '../../../common/DateRangePicker';
import dayjs from 'dayjs';
import formatNumberWithCommas from '../../../../helpers/numberWithCommasHelper';

export default class InvestmentManagementView extends JQueryView {
  constructor() {
    super('.l-investee-main');
    maskInput();
    this.memoFieldHidden();
    this.initTabScroll();
    if ($('.submit-button:visible').length === 0) {
      this.enableEditButton();
    }

    if ($('.investee-edit-content').length > 0) {
      this.initDateRangePicker(this.$el);
    }
  }

  // インフォメーションカードの×ボタンで非表示にする
  @on({ event: 'click', selector: '.cancel-information' })
  onClickCancelInformation() {
    $('.information').addClass('d-none');
  }

  // インフォメーションカードのボタンでスクロールさせる
  @on({ event: 'click', selector: '.js-information-scroll' })
  onClickInformationScroll() {
    $('html,body').animate(
      { scrollTop: $('.investment-container').position().top },
      200,
    );
  }

  memoFieldHidden() {
    $('.js-memo-fields').each((_, element) => {
      const height = $(element)[0].clientHeight;
      // 隠す必要のない行数のheight(192) + padding(16)で208を設定
      if (height > 208) {
        $(element).addClass('memo_fields_hidden');
        $(element)
          .parents('.js-memo-field-container')
          .find('.js-open-memo')
          .removeClass('d-none');
        $(element)
          .parents('.js-memo-field-container')
          .find('.js-close-memo')
          .addClass('d-none');
      }
    });
  }

  // 「さらに表示」押下で非表示のメモをすべて見せる
  @on({ event: 'click', selector: '.js-open-memo' })
  onClickShowMemos(event: any) {
    $(event.target)
      .parents('.js-memo-field-container')
      .find($('.js-memo-fields'))
      .removeClass('memo_fields_hidden');
    $(event.target)
      .parents('.js-memo-field-container')
      .find('.js-close-memo')
      .removeClass('d-none');
    $(event.target).addClass('d-none');
  }

  // 「閉じる」押下でメモの表示量を制限する
  @on({ event: 'click', selector: '.js-close-memo' })
  onClickHideMemos(event: any) {
    $(event.target)
      .parents('.js-memo-field-container')
      .find($('.js-memo-fields'))
      .addClass('memo_fields_hidden');
    $(event.target)
      .parents('.js-memo-field-container')
      .find('.js-open-memo')
      .removeClass('d-none');
    $(event.target).addClass('d-none');
  }

  initDateRangePicker = (container: any) => {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: false,
        timePicker: false,
        showDropdowns: true,
        maxDate: dayjs(),
        locale: {
          format: 'YYYY/MM/DD',
        },
      },
      {
        picker: {
          format: {
            start: 'YYYY/MM/DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  };

  initTabScroll() {
    const targetTab = $('.tab-active:visible');
    const targetTabRight = targetTab.width() + targetTab.offset().left;
    const containerWidth = $('.investment-summary-tab:visible').width();
    const containerLeft = $('.investment-summary-tab:visible').offset().left;
    const containerRight = containerWidth + containerLeft;
    const targetTabLeft = targetTab.offset().left - containerLeft;
    if (targetTabRight > containerRight) {
      $('.investment-summary-tab:visible').animate(
        { scrollLeft: targetTabLeft },
        100,
      );
    }
  }

  calcNetAssetsPerStock() {
    const totalStockQuantity = parseInt(
      $('#company_investee_total_stock_quantity')
        .val()
        .replace(/,/g, '') || 0,
    );
    const netAssets = parseInt(
      $('#company_investee_net_assets')
        .val()
        .replace(/,/g, '') || 0,
    );

    let formatResult =
      totalStockQuantity === 0 || netAssets === 0
        ? 0
        : (netAssets / totalStockQuantity).toFixed(2);

    // 整数部に桁区切り（3桁ごとのカンマ）を追加して、画面に表示する値を生成
    const result = formatNumberWithCommas(formatResult);

    $('#company_investee_net_assets_per_stock').val(result);
  }

  calcBookValuePerStock() {
    const totalStockQuantity = parseInt(
      $('#company_investee_investment_summary_total_stock_quantity')
        .val()
        .replace(/,/g, '') || 0,
    );
    const bookValue = parseInt(
      $('#company_investee_investment_summary_book_value')
        .val()
        .replace(/,/g, '') || 0,
    );

    let formatResult =
      totalStockQuantity === 0
        ? 0
        : (bookValue / totalStockQuantity).toFixed(2);

    // 整数部に桁区切り（3桁ごとのカンマ）を追加して、画面に表示する値を生成
    const result = formatNumberWithCommas(formatResult);

    $('#company_investee_investment_summary_book_value_per_stock').val(result);
  }

  enableEditButton() {
    $('.new-edit-button').each((index, element) => {
      const $dropdown = $(element).parents('.dropdown');
      if ($dropdown.length > 0) {
        $dropdown.removeClass('edit-button-disable');
        $dropdown
          .find('.menu')
          .addClass('c-text--orange')
          .removeClass('c-text--gray');
      } else {
        $(element).removeClass('edit-button-disable');
      }
    });
    $('.add-investment-button').show();
  }

  @on({ event: 'click', selector: 'input[type="submit"]' })
  trimCommasFromValue() {
    $('.currency').each((index, element) => {
      const input = $(element);
      input.val(trimCommas(input.val()));
    });

    const MINUS_NUMBER_WITH_COMMAS = /^-?([0-9]{1,3}(,[0-9]{3})*(\.[0-9]+)?|\.[0-9]+)$/;
    const value = $('#company_investee_net_assets').val();
    $('#company_investee_net_assets').val(
      MINUS_NUMBER_WITH_COMMAS.test(value) ? value.replace(/,/g, '') : value,
    );
  }

  @on({ event: 'click', selector: '.add-investment-button' })
  onClickAddInvestmentButton(event: any) {
    $('.new-edit-button').each((index, element) => {
      const $dropdown = $(element).parents('.dropdown');
      if ($dropdown.length > 0) {
        $dropdown.addClass('edit-button-disable');
        $dropdown
          .find('.menu')
          .removeClass('c-text--orange')
          .addClass('c-text--gray');
      } else {
        $(element).addClass('edit-button-disable');
      }
    });
    $(event.target).hide();
  }

  @on({ event: 'click', selector: '.new-edit-button' })
  onClickDisableEditButton() {
    $('.new-edit-button').each((index, element) => {
      const $dropdown = $(element).parents('.dropdown');
      if ($dropdown.length > 0) {
        $dropdown.addClass('edit-button-disable');
        $dropdown
          .find('.menu')
          .removeClass('c-text--orange')
          .addClass('c-text--gray');
      } else {
        $(element).addClass('edit-button-disable');
      }
    });
    $('.add-investment-button').hide();
  }

  @on({ event: 'change', selector: 'input, select' })
  changeInput() {
    const cancelButton = $('.buttun-before-replace');
    const newButton = $(
      '<button type="button" class="btn btn-outline-link" data-toggle="modal" data-target="#cancel_modal">キャンセル</button>',
    );

    cancelButton.replaceWith(newButton);
  }

  @on({ event: 'input', selector: '#company_investee_net_assets' })
  maskNetAssetsOnInput(event: any) {
    const $target = $(event.target);
    const sign = $target.val().startsWith('-') ? '-' : '';
    const absoluteValue = $target.val().replace(/[^\d]/g, '');

    $target.val(sign + absoluteValue.replace(/(\d)(?=(\d{3})+$)/g, '$1,'));
  }

  @on({ event: 'focusout', selector: '.currency-input' })
  focusoutInput(event: any) {
    const input = $(event.target);
    // 桁区切り（3桁ごとのカンマ）を削除
    let inputValue = input.val().replace(/[^0-9]+/g, '');
    if (inputValue.length > 12) {
      inputValue = inputValue.substr(0, 12);
      // 桁区切り（3桁ごとのカンマ）を追加
      const result = inputValue
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      $(input).val(result);
    }
  }

  @on({
    event: 'input',
    selector:
      '#company_investee_total_stock_quantity, #company_investee_net_assets',
  })
  onInputCompanyInvesteeTotalStockQuantity() {
    this.calcNetAssetsPerStock();
  }

  @on({
    event: 'input',
    selector: '#company_investee_investment_summary_book_value',
  })
  onInputBookValue() {
    this.calcBookValuePerStock();
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    target.toggleClass('form-control-active', target.val().length !== 0);
    target.removeClass('is-invalid');
    removeInvalidFeedback(target);
    target.removeClass('focus');
  }

  @on({ event: 'click', selector: '.cancel-button, #cancel_btn' })
  onClickCancelButton(event: any) {
    event.preventDefault();

    this.enableEditButton();

    if ($('#cancel_modal').is(':visible')) {
      $('#cancel_modal').modal('hide');
    }
    $('.show:hidden').removeClass('d-none');
    $('.form').remove();
  }
}
